import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { AuthService } from '@/services/auth.service'
import { Loader2 } from 'lucide-react'
import { useSearchParams } from 'next/navigation'
import { useState } from 'react'
import { toast } from 'sonner'
import { TelegramLoginButton } from './telegram-login-button'

export default function Enter() {
	const [email, setEmail] = useState('')
	const [password, setPassword] = useState('')
	const [loading, setLoading] = useState(false)

	const searchParams = useSearchParams()
	const productId: string | null = searchParams.get('product_id')

	function submitLogin(e: React.FormEvent<HTMLFormElement>) {
		e.preventDefault()
		setLoading(true)
		AuthService.login(email, password)
			.then(response => {
				if (response) {
					toast.success('Вход выполнен успешно!')
					// Редирект сразу, без setTimeout: iCloud Keychain предлагает
					// сохранить пароль, только когда навигация идёт вплотную за
					// сабмитом формы. Кнопку не разблокируем — мы уже уходим.
					if (productId) {
						window.location.href = `/profile/subscriptions/subscribe?product_id=${productId}`
					} else {
						window.location.href = '/profile'
					}
				} else {
					setLoading(false)
				}
			})
			.catch(error => {
				toast.error(error.response?.data?.message || 'Ошибка входа')
				setLoading(false)
			})
	}

	return (
		<form
			className='space-y-6 w-full max-w-md mx-auto p-6 rounded-lg shadow-lg bg-white/5 backdrop-blur-sm border border-gray-800'
			onSubmit={submitLogin}
		>
			<div className='space-y-4'>
				<div className='space-y-2'>
					<Label
						htmlFor='login-email'
						className='text-sm font-medium text-gray-200'
					>
						Почта
					</Label>
					{/* id/name/autoComplete обязательны: по ним Safari и iCloud
					    Keychain опознают пару «логин — пароль». name='username',
					    а не 'email', т.к. бэкенд ждёт почту в поле username. */}
					<Input
						id='login-email'
						name='username'
						type='email'
						autoComplete='username'
						inputMode='email'
						placeholder='yourmail@domain.com'
						className='w-full bg-gray-900/50 border-gray-800 focus:border-blue-500 focus:ring-blue-500 text-white'
						value={email}
						onChange={e => setEmail(e.target.value)}
						required
					/>
				</div>
				<div className='space-y-2'>
					<Label
						htmlFor='login-password'
						className='text-sm font-medium text-gray-200'
					>
						Пароль
					</Label>
					<Input
						id='login-password'
						name='password'
						type='password'
						autoComplete='current-password'
						placeholder='••••••••'
						className='w-full bg-gray-900/50 border-gray-800 focus:border-blue-500 focus:ring-blue-500 text-white'
						value={password}
						onChange={e => setPassword(e.target.value)}
						required
					/>
				</div>
			</div>
			<Button
				type='submit'
				disabled={loading}
				className='w-full bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white font-medium py-2 px-4 rounded-md transition-all duration-200 ease-in-out transform hover:scale-[1.02] active:scale-[0.98]'
			>
				{loading && <Loader2 className='animate-spin' />}
				Войти
			</Button>

			{/* Обёрнуто в один div, а не два отдельных ребёнка формы — иначе
			    space-y-6 формы добавляет по 24px с обеих сторон разделителя. */}
			<div className='space-y-3'>
				<div className='relative py-0.5'>
					<div className='absolute inset-0 flex items-center'>
						<span className='w-full border-t border-gray-800' />
					</div>
					<div className='relative flex justify-center text-xs'>
						<span className='bg-transparent px-2 text-gray-400'>или</span>
					</div>
				</div>

				<TelegramLoginButton />
			</div>
		</form>
	)
}
